import React from "react";
import { StatItem } from "./types";

/** Swipeable row of compact stat cards that bleeds to the screen edges. */
const MobileStatsStrip: React.FC<{ items: StatItem[] }> = ({ items }) => {
  if (items.length === 0) return null;

  return (
    <div className="-mx-4 overflow-x-auto overscroll-x-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div className="flex snap-x snap-mandatory gap-2.5 px-4">
        {items.map((item) => (
          <div
            key={item.label}
            className="flex min-w-[150px] max-w-[85%] shrink-0 basis-[44%] snap-start flex-col justify-between gap-3 rounded-2xl border border-gray-100 bg-white p-3.5 shadow-[0_1px_2px_rgba(13,14,19,0.04)]"
          >
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-medium leading-tight text-gray-500 line-clamp-2">
                {item.label}
              </span>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-primary-50 [&_svg]:h-4 [&_svg]:w-4">
                {item.icon}
              </span>
            </div>
            <div>
              <p className="whitespace-nowrap text-lg font-bold font-jakarta text-gray-900">{item.value}</p>
              {item.description && (
                <p className="mt-0.5 truncate text-[11px] font-medium text-emerald-600">
                  {item.description}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileStatsStrip;
